module.exports = __webpack_public_path__ + "img/cosmic_cat_depth.f18969bd.png";